export default __webpack_public_path__ + "static/media/cassette.fe79b48c.png";